// データテーブル詳細モーダル。
//
// 役割: データタブの行の詳細ボタンから開き、テーブル名・行数・列数と、属性プレビュー
//       （取込時に保持した先頭 10 件）を表形式で表示する。LayerDetailModal の非空間版。
// 関係: サンプルは data-service.importCsvDataTable が取込時に同梱済みのため追加クエリ不要。
function DataTableModal({ table, onClose }) {
  const columns = table.columns ?? []
  const sample = table.sample ?? []

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="modal modal-wide" onClick={(e) => e.stopPropagation()}>
        <h3>{table.displayName ?? table.tableId}</h3>

        <dl className="detail-fields">
          <dt>テーブル名</dt>
          <dd>
            <code>{table.tableId}</code>
          </dd>
          <dt>行数</dt>
          <dd>{table.rowCount ?? '—'}</dd>
          <dt>列数</dt>
          <dd>{columns.length}</dd>
        </dl>

        <div className="detail-preview">
          <div className="detail-preview-label">プレビュー（先頭 10 件）</div>
          {columns.length === 0 ? (
            <p className="detail-empty">列がありません</p>
          ) : (
            <div className="attr-table-wrap">
              <table className="attr-table">
                <thead>
                  <tr>
                    {columns.map((c) => (
                      <th key={c.name} title={`${c.name}: ${c.type}`}>
                        {c.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sample.map((row, i) => (
                    // 静的なプレビュー表示で並び替えがないため index を key に使う
                    // eslint-disable-next-line @eslint-react/no-array-index-key
                    <tr key={i}>
                      {columns.map((c) => {
                        const v = row[c.name]
                        const text = v == null ? '' : String(v)
                        return (
                          <td key={c.name} title={text}>
                            {text}
                          </td>
                        )
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  )
}

export default DataTableModal
